<template>
  <v-card class="border-none rounded-lg px-3 shadow-sm card-reward" no-body>
    <div class="rounded-lg p-3 overflow-hidden contant-reward">
      <div class="text-center">
        <b class="f-title">{{
          `${
            mission
              ? $t("mission_random_reward_title")
              : $t("random_reward_title")
          }`
        }}</b>

        <div class="text-gray mt-2">
          <small>{{
            getRewardList[count] && getRewardList[count].redeem_code
          }}</small>
        </div>
      </div>
      <lottie-player
        autoplay
        :loop="true"
        mode="normal"
        background="transparent"
        direction="1"
        class="box-animation"
        src="https://lottie.host/1776e287-8136-49e3-bf99-296c592ad298/gMmOqfbV9c.json"
        style="width: 100%; height: 300px"
      ></lottie-player>
      <!-- <div class="opened-box">
        <c-img
          :src="require('@/assets/images/thaniya_reward_2.gif')"
          @error="handleImageSrc"
          class="image-reward"
        ></c-img>
      </div> -->
      <p class="text-center mt-3 f-body-lg" id="previewMessage">
        {{
          mission
            ? $t("mission_random_reward_description")
            : $t("random_reward_description")
        }}
      </p>
      <div class="text-center">
        <c-btn
          pill
          variant="confirm-primary"
          class="shadow-box mb-2 mt-0 btn-open-box"
          @click="skipAnimate()"
          data-test="step2-skip-btn"
        >
          <span data-lang="skip"> {{ $t("skip") }}</span>
        </c-btn>
        <div style="height: 24px"></div>
      </div>
    </div>
  </v-card>
</template>

<script>
require("@lottiefiles/lottie-player");

var timeout = null;
export default {
  // components: {
  //   LottiePlayer
  // },
  props: {
    countList: { required: true },
    getRewardList: { required: true },
    count: { required: true },
    mission: {
      required: false,
      default: false,
      type: Boolean
    }
  },
  data() {
    return {};
  },
  mounted() {
    timeout = setTimeout(() => {
      this.$emit("next");
    }, 1300);
  },
  methods: {
    skipAnimate() {
      clearTimeout(timeout);
      // this.caseReceiveReward();
      this.$emit("next", true);
    }
  }
};
</script>
